export default __webpack_public_path__ + "static/media/bioengg-icon.9b50456e.svg";